"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IPoint.js.map